module.exports = __webpack_public_path__ + "static/img/mode1-3.18f77beb.png";